import type { EmailMessage, EmailTransport } from "./types.js";

/**
 * Reference transport for local dev/tests only - writes a redacted
 * summary (recipient + subject, never the full body) to the console
 * rather than logging PII, and never sends a real email. Not for
 * production use; a real deployment supplies its own `EmailTransport`
 * backed by a verified provider (SES, SendGrid, Postmark, a WordPress
 * mail function, ...) that holds its own credentials outside this
 * package entirely.
 */
export class ConsoleEmailTransport implements EmailTransport {
  async send(message: EmailMessage): Promise<void> {
    // eslint-disable-next-line no-console
    console.log(`[email] would send "${message.subject}" to ${message.to}`);
  }
}

/** No-op transport for tests/environments that must not send or log anything. */
export class NullEmailTransport implements EmailTransport {
  async send(_message: EmailMessage): Promise<void> {
    // intentionally empty
  }
}
